import React from 'react';
import { setCurrentView } from 'core/utils';
import { ShipmentInforReturnDetailListViewstore } from 'modules/shipment-info-return/stores';
import { ShipmentInfoReturnDetailListTemplate } from 'themes/modules/shipment-info-return/pages';

@setCurrentView(
	(rootStore, props) => new ShipmentInforReturnDetailListViewstore(rootStore, props),
	'shipmentInfoReturnDetailListViewStore'
)
class ShipmentInfoReturnDetailList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ShipmentInfoReturnDetailListTemplate store={this.props.shipmentInfoReturnDetailListViewStore} />;
	}
}

export default ShipmentInfoReturnDetailList;



// WEBPACK FOOTER //
// ./src/modules/shipment-info-return/pages/ShipmentInfoReturnDetailList.jsx